<template>
  <div v-if="show" :class="positionName">
    <module-title
      v-if="title"
      :title="title"
      class="module-title"
      :icon="icon"
    />
    <div v-if="columnsShowList" class="columnsShowList">
      <div
        v-for="(v, i) in moudelsList[positionName].list"
        :key="i"
        class="columnsShowList-item"
      >
        <div
          class="itme-warp border-radius"
          :style="`width: ${size.width}px;height: ${size.height}px;`"
        >
          <div :link="v.moduleUrl" @click="jumpLink(v.moduleUrl)">
            <img
              v-if="v.imgUrl"
              :src="v.imgUrl"
              class="image"
              width="100%"
              :alt="v.resourceName"
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="columnsShow">
      <div
        class="itme-warp border-radius"
        :style="`width: ${size.width}px;height: ${size.height}px;cursor: pointer;`"
      >
        <div
          :link="moudelsList[positionName].url || ''"
          @click="jumpLink(moudelsList[positionName], positionName)"
        >
          <img
            v-if="moudelsList[positionName].imgUrl"
            :src="moudelsList[positionName].imgUrl"
            class="image"
            width="100%"
            :alt="moudelsList[positionName].title"
          >
        </div>
      </div>
    </div>
    <div v-else>
      <div :style="`width: ${size.width}px;height: ${size.height}px;`" class="iframe-warp">
        <div
          v-if="moudelsList[positionName].moduleType === 2"
          class="imgbox"
          :class="[borderBox ? '' : 'borderBox']"
        >
          <div v-if="iframeShow">
            <iframe
              :ref="positionName"
              :name="positionName"
              width="100%"
              :height="size.height"
              frameborder="0"
              :src="moudelsList[positionName].list[0].moduleCode"
              scrolling="no"
            />
          </div>
        </div>
        <div
          v-if="moudelsList[positionName].moduleType === 3"
          class="imgbox borderBox"
        >
          <div v-if="moudelsList[positionName].list.length > 1">
            <!-- banner独有效果开屏 -->
            <div
              :class="[positionName === 'main_topleft' ? 'map_box_banner' : '']"
            >
              <el-carousel
                :interval="5000"
                arrow="always"
                :height="`${size.height}px`"
              >
                <el-carousel-item
                  v-for="item in moudelsList[positionName].list"
                  :key="item.id"
                >
                  <a
                    :href="item.moduleUrl | urlAddToken"
                    :title="item.resourceName"
                    :target="item.moduleUrl ? '_blank' : '_self'"
                  >
                    <div
                      :style="`width: 100%;background: url(${item.imgUrl}) center center;background-size:auto 100% ;height: ${size.height}px;`"
                      class="img"
                    />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div v-else-if="moudelsList[positionName].list.length > 0">
            <a
              :href="moudelsList[positionName].list[0].moduleUrl | urlAddToken"
              :title="moudelsList[positionName].list[0].resourceName"
              :target="
                moudelsList[positionName].list[0].moduleUrl ? '_blank' : '_self'
              "
            >
              <div
                :class="[
                  positionName === 'main_topleft' ? 'map_box_banner' : ''
                ]"
              >
                <div
                  :style="`width: 100%;background: url(${moudelsList[positionName].list[0].imgUrl}) center center;background-size:100% 100% ;height: ${size.height}px;`"
                  class="img"
                />
              </div>
            </a>
          </div>
        </div>
        <div
          v-if="moudelsList[positionName].moduleType === 10"
          class="imgbox tag_list"
        >
          <el-tabs
            v-if="moudelsList[positionName].list.length > 1"
            v-model="activeName"
            @tab-click="handleTabClick"
          >
            <el-tab-pane
              v-for="(v, i) of moudelsList[positionName].list"
              :key="`iframeindex${i}`"
              :name="`iframeindex${i}`"
            >
              <span slot="label" class="tag_list_tilte" :title="v.resourceName">
                <img v-show="v.imgUrl" :src="v.imgUrl" alt="" class="pdR5">{{
                  v.resourceName
                }}</span>
              <iframe
                :id="`${positionName}_iframeindex${i}`"
                :ref="`${positionName}_iframeindex${i}`"
                :name="`${positionName}_iframeindex${i}`"
                width="100%"
                :height="size.heightTag"
                frameborder="0"
                :src="v.moduleUrl"
                scrolling="no"
              />
            </el-tab-pane>
          </el-tabs>
          <div v-else class="tag_list_one">
            <div class="moduleTitle-name left">
              <img
                v-show="moudelsList[positionName].list[0].imgUrl"
                :src="moudelsList[positionName].list[0].imgUrl"
                alt=""
                class="pdR5"
              >{{ moudelsList[positionName].list[0].resourceName }}
            </div>
            <iframe
              :id="`${positionName}_iframeindex${0}`"
              :ref="`${positionName}_iframeindex${0}`"
              :name="`${positionName}_iframeindex${0}`"
              width="100%"
              :height="size.heightTag"
              frameborder="0"
              :src="moudelsList[positionName].list[0].moduleUrl"
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ModuleItem',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    positionName: {
      type: String,
      required: true
    },
    size: {
      type: Object,
      default: function() {
        return { height: 250, heightTag: 320 };
      }
    },
    showType: {
      type: String,
      default: function() {
        return '';
      }
    },
    icon: {
      type: String,
      default: function() {
        return 'icon1';
      }
    },
    borderBox: {
      type: String,
      default: function() {
        return '';
      }
    }
  },
  computed: {
    ...mapGetters(['moudelsList', 'activeNameTag']),
    activeName: {
      get() {
        return this.activeNameTag;
      },
      set(value) {
        this.$store.commit('SET_ACTIVENAMETAG', value);
      }
    },
    show() {
      // 模块显示
      return (
        this.moudelsList[this.positionName] &&
        (this.moudelsList[this.positionName].showType === 1 ||
          (this.moudelsList[this.positionName].imgUrl &&
            this.showType === 'columns') ||
          (this.moudelsList[this.positionName].list.length > 0 &&
            (this.moudelsList[this.positionName].moduleType === 3 ||
              (this.moudelsList[this.positionName].moduleType === 2 &&
                this.moudelsList[this.positionName].list[0].moduleCode) ||
              this.moudelsList[this.positionName].moduleType === 10)))
      );
    },
    columnsShow() {
      // 标签显示
      return (
        this.showType === 'columns' &&
        this.moudelsList[this.positionName].moduleType !== 10
      );
    },
    columnsShowList() {
      // 列表显示
      return this.showType === 'columnsShowList';
    },
    iframeShow() {
      // 通用类型iframe显示
      return (
        this.moudelsList[this.positionName].list.length > 0 &&
        this.moudelsList[this.positionName].list[0].moduleCode
      );
    }
  },
  methods: {
    handleTabClick(val) {
      this.activeName = val.name;
      if (val.name === 'iframeindex0') {
        this.$util.doIFrameFunc('init', null, 'main_tag_iframeindex0');
      }
    },
    jumpLink(val, positionName) {
      if (val.url) {
        if (
          !this.$util.urlAddToken(val.url, positionName === 'main_resource4')
        ) {
          this.$message({
            type: 'warning',
            message: '登录后才可查看该内容'
          });
          setTimeout(() => {
            this.$emit('login');
          }, 1000);
        } else {
          window.open(this.$util.urlAddToken(val.url));
        }
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.tag_list {
  .el-tabs__content {
    padding: 5px 40px 50px 40px;
  }

  .el-tabs__item.is-active {
    color: #007afc;
  }

  .el-tabs__active-bar {
    width: 40px !important;
    left: 20px;
    height: 6px;
    background-color: #007afc;
  }

  .el-tabs__nav {
    float: none;
    display: inline-block;
  }

  .el-tabs__nav-wrap .el-tabs__nav-prev,
  .el-tabs__nav-wrap .el-tabs__nav-next {
    width: 34px;
    height: 84px;
    // background: rgba(0,0,0,0.4);
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    // color: #fff;
  }

  .tag_list_tilte {
    width: 80px !important;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    display: inline-block;
  }

  .el-tabs__nav-wrap::after {
    background-color: transparent;
    border-bottom: #ccc 1px dashed;
  }

  .el-tabs__nav-scroll {
    padding: 0 80px;
    text-align: center;
  }

  .el-tabs__item {
    height: 84px;
    line-height: 84px;
    padding: 0 40px;
    font-size: 20px;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.tag_list_one {
  padding-top: 0px;
}

.moduleTitle-name {
  color: #333;
  font-size: 26px;
  margin-right: 20px;
  padding: 30px 0px;
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: bold;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.warp {
  display: flex;
  height: 250px;

  .left {
    width: 200px;
    height: 250px;
    margin-right: 30px;
    overflow: hidden;
  }

  .right {
    flex: 1;
  }
}

.imgbox {
  width: 100%;
  height: 100%;
  overflow: hidden;

  img,
  .img {
    transition: transform 0.2s;
    transform: scale(1);
  }

  &:hover img,
  &:hover .img {
    transform: scale(1.05);
  }
}

.itme-warp {
  width: 100%;
  height: 100%;
  overflow: hidden;

  img,
  .image {
    transition: transform 0.2s;
    transform: scale(1);
  }

  &:hover img,
  &:hover .image {
    transform: scale(1.05);
  }
}

.main_topleft {
  &:hover img,
  &:hover .img {
    transform: scale(1);
  }
}

.map_box_banner {
  height: 500px;
  overflow: hidden;
  animation: spread 2s linear forwards;
  position: absolute;
  left: 50%;
  right: 50%;
  text-align: center;
}

.map_box_banner::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: inherit;
  width: 26px;
  background: url('~@/assets/img/axis.png');
  z-index: 9;
  animation: spreadOpacity 2s linear forwards;
  opacity: 1;
}

.map_box_banner::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  height: inherit;
  width: 26px;
  background: url('~@/assets/img/axis.png');
  z-index: 9;
  animation: spreadOpacity 2s linear forwards;
  opacity: 1;
}

@keyframes spread {
  form {
  }

  to {
    left: 0;
    right: 0;
  }
}

@keyframes spreadOpacity {
  0% {
    opacity: 1;
  }

  99% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.main_resource1,
.main_resource2,
.main_resource3,
.main_resource4 {
  padding-right: 16px;
}

.border-radius {
  border-radius: 8px;
}

.columnsShowList {
  // display:inline-block
}

.columnsShowList-item {
  padding-right: 15px;
  display: inline-block;
}

.columnsShowList-item:last-child {
  padding-right: 0;
}
</style>
